import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MessageSericeComponent } from '../message/messageService.component';
import { MessageService } from '../message/messageService.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    MessageSericeComponent
  ],
  providers: [MessageService],
  exports: [
    MessageSericeComponent
  ]
})

export class MessageModule { }
